import { Injectable, EventEmitter, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { SegmentValidationService } from 'shared/validation/segment-validation/segment-validation.service';
import { rightPanelNavs } from './right-panel-navs';
import { digitalAssetsSegmentData } from './digital-assets-segment-data';
import { pageOptions } from './page-options';


@Injectable()
export class DigitalAssetDetailsService {

  uiModel: any = {
    isHeaderMinSubject: new BehaviorSubject<boolean>(false),
    isHeaderMinimized: false,
    headerMinHeight: pageOptions.headerMinHeight,
    segmentItemOffsets: pageOptions.segmentItemOffsets,
  };

  model: any = {
    id: null,
    segment: '',
    isPanelOpened: false,
    details: digitalAssetsSegmentData,
    assignments: null,
  };
}
